export const SetNewUserModal = (open) => {
  return {
    type: "SET_NEW_USER_MODAL",
    set_new_user_open: open,
  };
};
export default SetNewUserModal;
